var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('am-typography',{attrs:{"variant":"body1"},domProps:{"innerHTML":_vm._s(_vm.stepBackSubheader)},on:{"click":_vm.onRestoreByEmail}})
}
var staticRenderFns = []

export { render, staticRenderFns }